import { makeStyles } from "@material-ui/core"
import { CategoryToLabel } from "@pulseops/common"
import i18next from "i18next"

export namespace BasicSearchConst {
  export enum CancelPaymentStatus {
    Accept = 'ACCEPT_CANCEL',
    Reject = 'REJECT_CANCEL'
  }
  export const cashLessTransactions = [
    'CASHLESS_O1',
    'CASHLESS_O2',
    'CASHLESS_O3',
    'CASHLESS_DK',
    'CASHLESS_C9',
    'CASHLESS_P2',
    'CASHLESS_V2',
    'CASHLESS_M2',
    'CASHLESS_A9',
    'CASHLESS_S6',
    'CASHLESS_L3',
    'CASHLESS_D7',
    'CASHLESS_I2',
    'CASHLESS_M3',
    'CASHLESS_V4',
    'CASHLESS_A0',
    'CASHLESS_I4',
    'CASHLESS_P9',
    'CASHLESS_A7',
    'CASHLESS_S1',
    'CASHLESS_B3',
    'CASHLESS_P3',
    'CASHLESS_S2',
    'CASHLESS_S3',
    'CASHLESS_C3',
    'CASHLESS_U3',
    'CASHLESS_V3',
    'CASHLESS_I3',
    'CASHLESS_C7',
    'CASHLESS_X1',
    'CASHLESS_T3',
    'CASHLESS_M9',
    'CASHLESS_D6',
    'CASHLESS_D8',
    'CASHLESS_D9',
    'CASHLESS_V5',
    'CASHLESS_Q2'
  ]

  export const cancelPaymentLabel = [
    {
      value: CancelPaymentStatus.Accept,
      label: 'Accept cancel'
    },
    {
      value: CancelPaymentStatus.Reject,
      label: 'Reject cancel'
    }
  ]
  export const selectOptionOBAndIB = [
    { label: 'Outbound', value: 'OUTBOUND' },
    { label: 'Inbound', value: 'INBOUND' }
  ]

  export const convertCategoryToLabel = (category: string): string => {
    const converted = CategoryToLabel(category)
    if (converted) {
      return i18next.t(`Reports:${converted}`)
    } else {
      return ''
    }
  }

  export const makeBasicStyles = makeStyles({
    tableHeader: {
      backgroundColor: '#E5EAEF'
    },
    tableCell: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap'
    },
    cellNoWrap: {
      whiteSpace: 'nowrap'
    }
  })
}